export class ValidationRule {
    static rules: { [key: string]: { regex: RegExp; validationFailedText: string } } = {
        email: {
            // regex: /^[\w-]+(\.[\w-]+)*@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/,
            regex: /^[a-zA-Z0-9._%+-]*@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/,
            validationFailedText: "*EMAIL FORMAT ISN'T VALID",
        },
        forgot_password_email: {
            regex: /^[\w-]+(\.[\w-]+)*@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/,
            validationFailedText: "*EMAIL FORMAT ISN'T VALID",
        },
        password: {
            regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\s!"#$%&'()*+,-\./:;<=>?@[\]\\^_`{|}])[A-Za-z\d\s!"#$%&'()*+,-\./:;<=>?@[\]\\^_`{|}]{8,}$/,
            validationFailedText: "*ENTER CORRECT PASSWORD",
        },
        firstName: {
            regex: /^[A-Za-z]{3,30}$/,
            validationFailedText: "*ENTER CORRECT FIRST NAME",
        },
        secondName: {
            regex: /^[A-Za-z]{3,30}$/,
            validationFailedText: "*ENTER CORRECT SECOND NAME",
        },
        emailCode: {
            regex: /^[0-9]{6}$/,
            validationFailedText: "*CODE FORMAT ISN'T VALID",
        }
    };
}
